import { PaymentFrequencyOption } from '@/graphql/generated';
import { useCreateOwnerContractContext, useUserLanguage } from '@/customHooks';
import textsData from '@/textData/CreateContractsTexts.json';

const PAYMENT_FREQUENCY_OPTIONS: PaymentFrequencyOption[] = [
  PaymentFrequencyOption.Monthly,
  PaymentFrequencyOption.Quarterly,
  PaymentFrequencyOption.Semiannually,
  PaymentFrequencyOption.Yearly,
];

export const SelectOwnerContractFrequencyPaymentMenu = () => {
  const { state, setFrequencyPayment } = useCreateOwnerContractContext();
  const userLanguage = useUserLanguage();

  const rootTexts = userLanguage === 'es' ? textsData.es : textsData.en;
  const texts = rootTexts.ownerContract.paymentType;

  const frequencyLabels: Record<string, { en: string; es: string }> = {
    [PaymentFrequencyOption.Monthly]: { en: 'Monthly', es: 'Mensual' },
    [PaymentFrequencyOption.Quarterly]: { en: 'Quarterly', es: 'Trimestral' },
    [PaymentFrequencyOption.Semiannually]: { en: 'Semiannually', es: 'Semestral' },
    [PaymentFrequencyOption.Yearly]: { en: 'Yearly', es: 'Anual' },
  };

  const getLabel = (option: PaymentFrequencyOption) => {
    return frequencyLabels[option][userLanguage === 'es' ? 'es' : 'en'];
  };

  const currentFrequency = state.paymentFrequencyOption;

  const handleChange = (frequency: PaymentFrequencyOption) => {
    setFrequencyPayment(frequency);
  };

  return (
    <div className="flex justify-center w-full">
      <div className="w-full max-w-3xl flex flex-col items-center">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 flex flex-col gap-8 w-full">
          <div className="text-center">
            <h2 className="text-xl font-bold text-gray-900 mb-2">{texts.title}</h2>
            <p className="text-sm text-gray-500">{texts.helper}</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {PAYMENT_FREQUENCY_OPTIONS.map((option) => (
              <button
                key={option}
                type="button"
                onClick={() => handleChange(option)}
                className={`flex-1 p-6 rounded-xl border-2 transition-all duration-200 text-center flex flex-col gap-2 items-center justify-center ${
                  currentFrequency === option
                    ? 'border-(--color-primary) bg-(--color-primary-50) text-(--color-primary)'
                    : 'border-gray-100 bg-white hover:border-gray-200 text-gray-600'
                }`}
              >
                <span className="font-semibold text-sm">
                  {getLabel(option)}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
